import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
// import { saleExport } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'
import { SaleExport } from 'depoto-core'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class SaleExportService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  // public async getsaleExport(id): Promise<saleExport> {
  //     return new saleExport(
  //         await this.core.services.saleExport.getById(id, {
  //             // todo
  //             id: null,
  //         })
  //     )
  // }

  async getSaleExports(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: SaleExport[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.saleExport.getList(parameters, schema)
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deletesaleExport(saleExport: Partial<saleExport>): Promise<saleExport> {todo
  //   return this.core.services.saleExport.dele(saleExport)
  // }
}
